import React, { JSX, useCallback, useReducer } from 'react';
import { useNavigate } from 'react-router';
import { Routes } from '../../app/Routes';
import { BlankPage } from '../../components/BlankPage/BlankPage';
import { Button } from '../../components/Button/Button';
import { formReducer } from '../../components/form/formReducer';
import { Input } from '../../components/Input/Input';
import { localized } from '../../config/localization';
import { forgotPassword } from '../../services/Auth';
import { EMAIL_PATTERN } from '../../utils';

export function ForgotPasswordPage(): JSX.Element {
  const [state, dispatch] = useReducer(formReducer, {
    values: {
      email: '',
    },
    errors: {
      email: null,
    },
    valid: false,
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      dispatch({ errors: { email: null } });

      forgotPassword(state.values.email)
        .then(() => {
          navigate(Routes.NEW_PASSWORD, { state: { email: state.values.email } });
        })
        .catch((error) => dispatch({ errors: { email: error.message } }));
    },
    [state.values.email, navigate]
  );

  return (
    <BlankPage title={localized.PASSWORD_RESET} showGoBack>
      <form onSubmit={onSubmit}>
        <Input
          autoFocus
          name="email"
          values={state.values}
          placeholder={localized.EMAIL}
          errors={state.errors}
          onChange={(event) => {
            const value = event.target.value.toLocaleLowerCase().trim();
            dispatch({
              values: { email: value },
              errors: { email: !EMAIL_PATTERN.test(value) ? localized.LOGIN_EMAIL_INVALID : null },
            });
          }}
        />
        <BlankPage.Buttons>
          <Button type="submit" disabled={!state.valid}>
            {localized.CONFIRM}
          </Button>
        </BlankPage.Buttons>
      </form>
    </BlankPage>
  );
}
